// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__bGa03","loadAnimation":"Spinner_loadAnimation__yS6Rn","text":"Spinner_text__TbKDw"};